// This component will span the available width and
// adjust it's height to keep provided aspect ratio
// https://css-tricks.com/snippets/sass/maintain-aspect-ratio-mixin/

import React, { FC } from 'react';
import styled from 'styled-components';

const Outer = styled.div<{ width: number; height: number }>`
  position: relative;
  max-height: ${p => (p.height / p.width) * 100}%;

  &:before {
    display: block;
    content: '';
    width: 100%;
    padding-top: ${p => (p.height / p.width) * 100}%;
  }
`;

const Inner = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

const Ratio: FC<{ width: number; height: number; style?: React.CSSProperties }> = props => (
  <Outer width={props.width} height={props.height} style={props.style}>
    <Inner>{props.children}</Inner>
  </Outer>
);

export default Ratio;
